/**
 * @prettier
 */
export function momentToLocalDate(date: any): Date {
    return new Date(date.year(), date.month(), date.date(), date.hours(), date.minutes(), date.seconds(), date.milliseconds());
}
